import React from "react";

import Home from "./Pages/home";

const App = () => {
  return <Home />;
};

export default App;
